/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 이미지 목록을 슬라이드형태로 변환하는 툴을 정의한다.
 *
 * @file /src/rootin/blocks/images/tools/Slide.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 7. 19.
 */
import { List } from './List';
import { Language, LanguageText } from '@utils/Language';

export class Slide extends List {
    /**
     * 툴타입
     */
    static type: string = 'slide';

    /**
     * 툴아이콘
     */
    icon: string =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-gallery-thumbnails-icon lucide-gallery-thumbnails"><rect width="18" height="14" x="3" y="3" rx="2"/><path d="M4 21h1"/><path d="M9 21h1"/><path d="M14 21h1"/><path d="M19 21h1"/></svg>';

    /**
     * 툴팁
     */
    text: LanguageText = Language.get('rootin.blocks.images.tools.slide');
}
